import Constants from 'app/shared/constants';

const ModalActions = {
    showModal(payload) {
        return {
            type: Constants.MODAL_SHOW,
            payload,
        };
    },
    updateModal(payload) {
        return {
            type: Constants.MODAL_UPDATE,
            payload,
        };
    },
    hideModal() {
        return {
            type: Constants.MODAL_HIDE,
        };
    },

    // TODO: clean up
    updateDisplayAddPropertyModal(payload) {
        return dispatch => dispatch({
            type: Constants.MODAL_ADD_PROPERTY_UPDATE_DISPLAY,
            payload,
        });
    },
    updateDisplayEnableApplicationsModal(status) {
        return dispatch => dispatch({
            type: Constants.MODAL_ENABLE_APPLICATIONS_UPDATE_DISPLAY,
            payload: status,
        });
    },
    updateDisplayImageCarouselModal(payload) {
        return dispatch => dispatch({
            type: Constants.MODAL_IMAGE_CAROUSEL_UPDATE_DISPLAY,
            payload,
        });
    },
    updateDisplayVerifyEmailModal(payload) {
        return dispatch => dispatch({
            type: Constants.MODAL_VERIFY_EMAIL_UPDATE_DISPLAY,
            payload,
        });
    },
    updateDisplayVerifyEmailFailureModal(payload) {
        return dispatch => dispatch({
            type: Constants.MODAL_VERIFY_EMAIL_FAILURE_UPDATE_DISPLAY,
            payload,
        });
    },
};

export default ModalActions;
